import * as Yup from 'yup';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';

export interface RailBillingProps {
	consignmentId: number;
	dispatchLeg: DispatchLeg;
}

export interface RailBillingForm {
	emailAddr: string;
	emailSubject: string;
	emailBody: string;
}

export const initialFormValues = {
	emailAddr: '',
	emailSubject: '',
	emailBody: ''
};

export const RailBillingValidationSchema = Yup.object<RailBillingForm>().shape(
	{
		emailAddr: Yup.string()
			.required('Email Address is required to send')
			.test('emailValidation', 'Please enter one or more valid Email Addresses', (value) => {
				if (!value) return true;
				const emails = value.split(',');
				return emails.every((email) =>
					Yup.string()
						.email()
						.matches(/^[^@]+@[^@]+\.[^@]+$/)
						.isValidSync(email)
				);
			}),
		emailSubject: Yup.string().required('Subject is required for Email'),
		emailBody: Yup.string().required('Message is required for Email')
	},
	[]
);
